// extracted by mini-css-extract-plugin
module.exports = {"Button":"NavButton_Button__3mz08","Success":"NavButton_Success__3Qg7V","Danger":"NavButton_Danger__25mtG"};